import {COLUMN_ACCESS_GROUP, COLUMN_ACCESS_GROUP_SITE, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_SITE, COLUMN_TIME_PATTERN} from "../../constants/column-types";
import { FILTER_ACCESS_GROUP, FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_SITES, FILTER_TAGHOLDERS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const GeneralAccessReportColumns: TableColumn[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: "master",
    },
    {
        heading: "First Name",
        accessor: "firstName",
        sortDirection: "asc",
        sortByName: "mstFirstname",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        sortDirection: "asc",
        sortByName: "mstLastname",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        searchOnName: "siteId",
        lookupName: "site",
        filterId: FILTER_SITES,
        settingDataName: "site",
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 4,
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        searchOnName: "companyId",
        lookupName: "company",
        filterId: FILTER_COMPANIES,
        settingDataName: "company",
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        searchOnName: "departmentId",
        lookupName: "department",
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department",
    },
    {
        heading: "Access Group",
        accessor: "accessGroup",
        isNumeric: false,
        id: 6,
        active: false,
        translationKey: "accessGroup",
        columnId: COLUMN_ACCESS_GROUP,
        searchOnName: "accessGroupId",
        lookupName: "accessGroupId",
        filterId: FILTER_ACCESS_GROUP,
        settingDataName: "accessGroup",
        isFilterOnlyColumn: true,
    }
];

export const GeneralAccessReportChildColumns: TableColumn[] = [
    {
        heading: "Access Group",
        accessor: "accessGroupName",
        isNumeric: false,
        id: 10,
        active: true,
        translationKey: "accessGroup",
        columnId: COLUMN_ACCESS_GROUP,
    },
    {
        heading: "Access Group Site",
        accessor: "accessGroupSite",
        isNumeric: false,
        id: 11,
        active: true,
        translationKey: "accessGroupSite",
        columnId: COLUMN_ACCESS_GROUP_SITE,
    },
    {
        heading: "Access Time Pattern",
        accessor: "accessTimePatternName",
        isNumeric: false,
        id: 12,
        active: true,
        translationKey: "accessTimePattern",
        columnId: COLUMN_TIME_PATTERN,
    },
];

export default GeneralAccessReportColumns;
